import React, { Component } from 'react';
import { Link } from 'react-router';

import { StyledBtnOffice } from './styles/StyledBtnOffice';

class BtnOffice extends Component {
  render() {
    const { id, title, text, handleOnMouseMoveBtnOffice, position} = this.props;

    return (
      <StyledBtnOffice>
        <div className="disable-select btn-office-container">
          <Link className="btn-office-content"
            to={'/office/' + id}
            onMouseMove={e => handleOnMouseMoveBtnOffice(e, position, id)}
          >
            <table className="btn-office-table">
              <tbody>
                <tr>
                  <td>
                    <div className="btn-office-title">
                      { title }
                    </div>
                    <div className="btn-office-address">
                      { text }
                    </div> 
                  </td>
                  <td className="btn-office-arrow">
                    <i className="fa fa-angle-right" aria-hidden="true"></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </Link>
        </div>
      </StyledBtnOffice>
    );
  }
}

export default BtnOffice;


// WEBPACK FOOTER //
// ./src/common/BtnOffice/BtnOffice.js